import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import BottomFooter from '../../index/layout/bottomFooter';
import BackToTop from './backToTop';
import FlashList from './flashList';

const LOGO_URL =
    'https://x0.ifengimg.com/ucms/2026_32/C9F6D2AB0A51C6D6B666F70197C7239EDD4F9CCD_size17_w559_h164.png';

const Layout = ({ content }) => {
    const { footer, list = [] } = content;

    return (
        <div className={styles.layout}>
            <header className={styles.pageHeader}>
                <div className={styles.titleBox}>
                    <a className={styles.logoLink} href="//www.ifeng.com/" aria-label="返回凤凰网首页">
                        <img className={styles.logoImg} src={LOGO_URL} alt="凤凰网" />
                    </a>
                    <h1 className={styles.pageTitle}>财经快讯</h1>
                    <a className={styles.backLink} href="https://original.ifeng.com/">
                        原创首页
                    </a>
                </div>
            </header>
            <main className={styles.main}>
                <FlashList content={list} />
            </main>
            <BottomFooter content={footer} />
            <BackToTop />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
